import { z } from 'zod';
import { DisplayNameSchema, PasswordSchema, UserSchema, UsernameSchema } from './auth.js';
export const InviteStatusSchema = z.enum(['pending', 'used', 'expired', 'revoked']);
export const InviteSchema = z.object({
    id: z.string(),
    note: z.string().nullable(),
    createdAt: z.string(),
    expiresAt: z.string(),
    status: InviteStatusSchema,
    usedBy: z.object({ id: z.string(), username: z.string() }).nullable(),
});
export const CreateInviteRequestSchema = z.object({
    note: z.string().trim().max(100).optional(),
    expiresInDays: z.number().int().min(1).max(30).default(7),
});
/** `url` carries the only copy of the invite token; it is shown once. */
export const CreateInviteResponseSchema = z.object({ invite: InviteSchema, url: z.string() });
export const InvitesResponseSchema = z.object({ invites: z.array(InviteSchema) });
export const InviteLookupResponseSchema = z.object({ expiresAt: z.string() });
export const RedeemInviteRequestSchema = z.object({
    username: UsernameSchema,
    displayName: DisplayNameSchema,
    password: PasswordSchema,
});
/** `joinedVia` and preview space in MB, `fullSpace` = the server's default (docs 64–65). */
export const AdminUserSchema = UserSchema.extend({
    disabled: z.boolean(),
    joinedVia: z.enum(['setup', 'invite', 'signup']).default('invite'),
    previewMb: z.number().default(0),
    fullSpace: z.boolean().default(true),
});
export const SetPreviewSpaceRequestSchema = z.object({ limited: z.boolean() });
export const AdminUserResponseSchema = z.object({ user: AdminUserSchema });
export const AdminUsersResponseSchema = z.object({ users: z.array(AdminUserSchema) });
//# sourceMappingURL=admin.js.map